<template lang="pug">

div( v-if="showAlert" )
  div( class="position-relative" )
    div( class="text-center" v-bind:class="alertClasses" )

      i(
        class="fa fa-trash text-danger delete-emcs"
        v-on:click="softDeleteEmcs"
        v-if="$moonpull.currentUserIsSuperAdmin() && enhancedMemoryCookieStatus && ! isDeleteProcessing"
      )

      div( v-if="enhancedMemoryCookieStatus" )

        p( class="mb-0" )
          | Result from {{ enhancedMemoryCookieStatus.sourceVerbiage }} on {{ emcsDateReadable }}:&nbsp;
          strong {{ enhancedMemoryCookieStatus.statusReadable }}
      
        p( v-if="enhancedMemoryCookieStatus.comment" class="mb-0 mt-1" )
          | #[strong Comment:] {{ enhancedMemoryCookieStatus.comment }}
      
      div( v-else-if="audit.injectedResult" )
        p( class="mb-0" )
          | Moonpull's own #[strong Guided Result] conducted on {{ guidedResultDateReadable }} is:&nbsp;
          strong {{ audit.injectedResult.template.readableStatus }}

      p( class="mb-0" )
        MModalButton(
          button-classes="btn btn-link p-0"
          button-text="View the Moonpull Platform result"
          modal-size="modal-lg"
          v-if="! isShowingPlatformResult"
        )
          div( slot="body" class="text-dark text-left" )
            p.
              Note:  the enhanced result stated on this bar is a
              more accurate result relating to the memory cookie.
            p.
              It is a BETA product. Therefore feedback is appreciated
            p.
              The full result is left as available as there will be
              information there for helping with understanding the
              tracking from the initial link through the redirects
              to the advertiser's landing page.
          
          div( slot="footer" class="text-right" )
            div( class="btn-group" )
              button( class="btn btn-secondary mr-2" v-on:click="emit('dismissModals')" ) Cancel
              button( class="btn btn-primary" v-on:click="showPlatformResult" ) I understand

</template>

<style lang="scss" scoped>
.delete-emcs {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}
</style>

<script>
import Vue from 'vue'
import { ref, computed, inject } from '@vue/composition-api'
import dateFormat from 'dateformat'
import gql from 'graphql-tag'
export default Vue.extend({

  props: {
    audit: {
      type: Object,
      required: true
    }
  },

  emits: [
    'showPlatformResult'
  ],

  setup(props, { emit }) {

    const $apollo = inject('$apollo')

    const { audit } = props

    const memoryCookieStatusClassMap = {
      IMMEDIATE: 'alert-success',
      CONDITIONAL_ON_CMP: 'alert-warning',
      CONDITIONAL_ON_CMP_AND_REFRESH: 'alert-warning',
      NO_MEMORY_COOKIE: 'alert-danger',
      CLOSED_ADVERTISER: 'alert-secondary',
      NOT_AUDITED: 'alert-secondary',
      MANUAL_REVIEW: 'alert-secondary',
      OTHER: 'alert-secondary',
    }

    // Alert settings
    const showAlert = computed(() => {
      return !! enhancedMemoryCookieStatus.value || !! audit.injectedResult
    })

    const alertClasses = computed(() => {
      if (enhancedMemoryCookieStatus.value) {
        return [
          'alert',
          memoryCookieStatusClassMap[enhancedMemoryCookieStatus.value.status],
        ]
      }
      else if (audit.injectedResult) {
        return [
          'alert',
          'alert-primary',
          'text-center',
        ]
      }
    })

    // advertiser comment
    const advertiserComment = computed(() => {
      return audit.advertiser?.publicComment
    })

    // EMCS

    const enhancedMemoryCookieStatus = computed(() => {
      return audit.enhancedMemoryCookieStatuses?.[0]
    })

    const emcsDateReadable = ref(dateFormat(enhancedMemoryCookieStatus.value?.updatedAt, 'dS mmmm yyyy'))

    // Guided Result

    function getIndefiniteArticle(word) {
      return ['a', 'e', 'i', 'o', 'u'].includes(word[0].toLowerCase()) ? 'an' : 'a'
    }

    function getPublisherTypeString() {
      const pt = audit.injectedResult.template.readablePublisherType
      return `${getIndefiniteArticle(pt)} ${pt}`
    }

    const guidedResultDateReadable = ref(dateFormat(audit.injectedResult?.template.updatedAt, 'dS mmmm yyyy'))

    // SU deletion of EMCS
    const isDeleteProcessing = ref(false)
    async function softDeleteEmcs() {

      if (! confirm('Are you sure you want to delete this Enhanced Memory Cookie Status?')) {
        return
      }

      isDeleteProcessing.value = true
      await $apollo.mutate({
        mutation: gql`
          mutation SoftDeleteMemoryCookieStatusById($id: ID!) {
            memoryCookieStatusSoftDeleteById(id: $id) {
              id
            }
          }
        `,
        variables: {
          id: enhancedMemoryCookieStatus.value.id
        },
      })
      audit.enhancedMemoryCookieStatuses = audit.enhancedMemoryCookieStatuses.filter(emcs => emcs.id !== enhancedMemoryCookieStatus.value.id)
      isDeleteProcessing.value = false
    }

    // Platform result disclaimer
    const isShowingPlatformResult = ref(false)
    function showPlatformResult() {
      emit('showPlatformResult')
      emit('dismissModals')
      isShowingPlatformResult.value = true
    }

    return {
      emit,
      dateFormat,
      showAlert,
      alertClasses,
      enhancedMemoryCookieStatus,
      advertiserComment,
      emcsDateReadable,
      getPublisherTypeString,
      guidedResultDateReadable,
      isDeleteProcessing,
      softDeleteEmcs,
      isShowingPlatformResult,
      showPlatformResult,
    }
  },
})
</script>
